var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"room__info-block block-room-description"},[_c('div',{staticClass:"block__content"},[(_vm.description.texts.length)?_c('div',{staticClass:"text"},_vm._l((_vm.description.texts),function(paragraph){return _c('pre',[_vm._v(_vm._s(paragraph.text ?? paragraph))])}),0):_vm._e()])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }